import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import jsPDF from 'jspdf';

import Helper from '../../helpers/helper';

import { setAppLoadingState } from '../../actions/app/app';
import { setSidebarItem } from '../../actions/sidebar/sidebar';

const ExportItem = props => {

  const dispatch = useDispatch(),
        mainviewProps = useSelector(store => store.mainview),
        sidebarProps = useSelector(store => store.sidebar);

  const _exportPDF = pdfSize => {

    dispatch(setAppLoadingState(true));
    
    const pdf = new jsPDF('p', 'px', pdfSize),
          pdfWidth = pdf.internal.pageSize.getWidth(), // 446px
          pdfHeight = pdf.internal.pageSize.getHeight(), // 631px
          date = new Intl.DateTimeFormat('en-AU').format(new Date());

    try {
      // PDF Header -----
      pdf.addImage(process.env.REACT_APP_AKF_Logo, 'PNG', 10, 10, 60, 60);
      pdf.fromHTML(`<h1 style="font-size: 25px; color: #00690F; font-family: Arial, sans-serif;">Australian Koala Foundation</h1>`, 80, 15);
      pdf.fromHTML(`<h2 style="font-size: 13px; color: #00690F; font-family: Arial, sans-serif;">The international organisation dedicated to saving the koala and its habitat</h2>`, 80, 35);
      // ----------------
      
      // PDF Map --------
      let mapImageHeight = pdfSize === 'a4' ?
        props.mapCanvas.width <= 700 ? 370 :
          props.mapCanvas.width > 701 && props.mapCanvas.width <= 1000 ? 360 :
            props.mapCanvas.width > 1001 ? 320 : 340
        :
        props.mapCanvas.width <= 700 ? 470 : // Start of A3 size logic
          props.mapCanvas.width > 701 && props.mapCanvas.width <= 1000 ? 460 :
            props.mapCanvas.width > 1001 ? 420 : 440;

      pdf.addImage(props.mapCanvas.toDataURL('image/png'), 'PNG', -20, 73, pdfWidth + 20, mapImageHeight);

      if (pdfSize === 'a4') {
        pdf.setFillColor('#fff');
        pdf.setDrawColor('#fff');
        pdf.rect(0, mapImageHeight, pdfWidth, 100, 'F');
      }

      const scaleControl = document.querySelector('.scaleControl'),
            scaleBarWidth = (scaleControl.children[0]?.offsetWidth / 2);

      pdf.setDrawColor('#000');
      pdf.setFillColor('#000');
      pdf.rect(pdfWidth - (scaleBarWidth + 23), pdfSize === 'a4' ? mapImageHeight - 7 : mapImageHeight + 61, scaleBarWidth, 1);
      pdf.fromHTML(`<p style="font-size: 10px; font-family: Arial, sans-serif;">${ scaleControl.children[1]?.textContent }</p>`, pdfWidth - 20, pdfSize === 'a4' ? mapImageHeight - 20 : mapImageHeight + 48);

      pdf.fromHTML(`<p style="font-size: 10px; font-family: Arial, sans-serif;">Date: ${ date }</p>`, pdfWidth - 48, pdfSize === 'a4' ? mapImageHeight - 5 : mapImageHeight + 70);
      pdf.fromHTML(`<p style="font-size: 10px; font-family: Arial, sans-serif; font-style: italic;">Koala Habitat Map and Koala Sightings Copyright Australian Koala Foundation. Other data Copyright respective Government Agencies.</p>`, 5, pdfSize === 'a4' ? mapImageHeight - 5 : mapImageHeight + 70);
      // ---------------

      // Optional pdf data depending on layer
      if (mainviewProps.showNVISHabitat) {
        pdf.setFillColor('#008561');
        pdf.rect(pdfSize === 'a4' ? 30 : 60, pdfSize === 'a4' ? 390 : 600, 25, 10, 'F');
        pdf.fromHTML(`<p style="font-size: ${ pdfSize === 'a4' ? '11px' : '15px' }; font-family: Arial, sans-serif;">80% - 100% Eucalyptus trees</p>`, pdfSize === 'a4' ? 60 : 90, pdfSize === 'a4' ? 385 : 595);

        pdf.setFillColor('#00CC82');
        pdf.rect(pdfSize === 'a4' ? 30 : 60, pdfSize === 'a4' ? 410 : 620, 25, 10, 'F');
        pdf.fromHTML(`<p style="font-size: ${ pdfSize === 'a4' ? '11px' : '15px' }; font-family: Arial, sans-serif;">50% - 80% Eucalyptus trees</p>`, pdfSize === 'a4' ? 60 : 90, pdfSize === 'a4' ? 405 : 615);

        pdf.setFillColor('#7FEDDE');
        pdf.rect(pdfSize === 'a4' ? 30 : 60, pdfSize === 'a4' ? 430 : 640, 25, 10, 'F');
        pdf.fromHTML(`<p style="font-size: ${ pdfSize === 'a4' ? '11px' : '15px' }; font-family: Arial, sans-serif;">20% - 50% Eucalyptus trees</p>`, pdfSize === 'a4' ? 60 : 90, pdfSize === 'a4' ? 425 : 635);

        pdf.setFillColor('#B8D9C7');
        pdf.rect(pdfSize === 'a4' ? 30 : 60, pdfSize === 'a4' ? 450 : 660, 25, 10, 'F');
        pdf.fromHTML(`<p style="font-size: ${ pdfSize === 'a4' ? '11px' : '15px' }; font-family: Arial, sans-serif;">less than 20% Eucalyptus trees</p>`, pdfSize === 'a4' ? 60 : 90, pdfSize === 'a4' ? 445 : 655);

        pdf.setFillColor('#FFC7A3');
        pdf.rect(pdfSize === 'a4' ? 30 : 60, pdfSize === 'a4' ? 470 : 680, 25, 10, 'F');
        pdf.fromHTML(`<p style="font-size: ${ pdfSize === 'a4' ? '11px' : '15px' }; font-family: Arial, sans-serif;">Unknown composition (no data)</p>`, pdfSize === 'a4' ? 60 : 90, pdfSize === 'a4' ? 465 : 675);
      }

      if (mainviewProps.showKHAHabitat || mainviewProps.showPreClearingHabitat) {
        pdf.setFillColor('#E74C3C');
        pdf.rect(pdfSize === 'a4' ? 30 : 60, pdfSize === 'a4' ? 385 : 575, 25, 10, 'F');
        pdf.fromHTML(`<p style="font-size: ${ pdfSize === 'a4' ? '10px' : '14px' }; font-family: Arial, sans-serif;"><b>Primary Habitat:</b> Areas of forest or woodland where primary koala food tree species comprise at least 50% of the overstorey trees.</p>`, pdfSize === 'a4' ? 60 : 90, pdfSize === 'a4' ? 375 : 565);
        pdf.fromHTML(`<p style="font-size: ${ pdfSize === 'a4' ? '10px' : '14px' }; font-family: Arial, sans-serif;">Capable of supporting high-density koala populations.</p>`, pdfSize === 'a4' ? 60 : 90, pdfSize === 'a4' ? 380 : 572);

        pdf.setFillColor('#079D51');
        pdf.rect(pdfSize === 'a4' ? 30 : 60, pdfSize === 'a4' ? 405 : 605, 25, 10, 'F');
        pdf.fromHTML(`<p style="font-size: ${ pdfSize === 'a4' ? '10px' : '14px' }; font-family: Arial, sans-serif;"><b>Secondary Habitat (Class A):</b> Areas of forest or woodland where primary koala food tree species comprise less than 50% but at least 30%</p>`, pdfSize === 'a4' ? 60 : 90, pdfSize === 'a4' ? 395 : 595);
        pdf.fromHTML(`<p style="font-size: ${ pdfSize === 'a4' ? '10px' : '14px' }; font-family: Arial, sans-serif;">of the overstorey trees; or where primary koala food tree species comprise less than 30% of the overstorey trees but together</p>`, pdfSize === 'a4' ? 60 : 90, pdfSize === 'a4' ? 400 : 602);
        pdf.fromHTML(`<p style="font-size: ${ pdfSize === 'a4' ? '10px' : '14px' }; font-family: Arial, sans-serif;">with secondary food tree species comprise at least 50% of the overstorey trees; or where secondary food tree species alone</p>`, pdfSize === 'a4' ? 60 : 90, pdfSize === 'a4' ? 405 : 609);
        pdf.fromHTML(`<p style="font-size: ${ pdfSize === 'a4' ? '10px' : '14px' }; font-family: Arial, sans-serif;">comprise at least 50% of the overstorey trees. Capable of supporting high to medium-density koala populations.</p>`, pdfSize === 'a4' ? 60 : 90, pdfSize === 'a4' ? 410 : 616);

        pdf.setFillColor('#74B374');
        pdf.rect(pdfSize === 'a4' ? 30 : 60, pdfSize === 'a4' ? 435 : 645, 25, 10, 'F');
        pdf.fromHTML(`<p style="font-size: ${ pdfSize === 'a4' ? '10px' : '14px' }; font-family: Arial, sans-serif;"><b>Secondary Habitat (Class B):</b> Areas of forest or woodland where primary koala food tree species comprise less than 30% of the</p>`, pdfSize === 'a4' ? 60 : 90, pdfSize === 'a4' ? 425 : 635);
        pdf.fromHTML(`<p style="font-size: ${ pdfSize === 'a4' ? '10px' : '14px' }; font-family: Arial, sans-serif;">overstorey trees; or where primary koala food tree species together with secondary food tree species comprise at least 30%</p>`, pdfSize === 'a4' ? 60 : 90, pdfSize === 'a4' ? 430 : 642);
        pdf.fromHTML(`<p style="font-size: ${ pdfSize === 'a4' ? '10px' : '14px' }; font-family: Arial, sans-serif;">(but less than 50%) of the overstorey trees; or where secondary food tree species alone comprise at least 30% (but less than 50%) of</p>`, pdfSize === 'a4' ? 60 : 90, pdfSize === 'a4' ? 435 : 649);
        pdf.fromHTML(`<p style="font-size: ${ pdfSize === 'a4' ? '10px' : '14px' }; font-family: Arial, sans-serif;">the overstorey trees. Capable of supporting medium to low density koala populations.</p>`, pdfSize === 'a4' ? 60 : 90, pdfSize === 'a4' ? 440 : 656);

        pdf.setFillColor('#C3F5B5');
        pdf.rect(pdfSize === 'a4' ? 30 : 60, pdfSize === 'a4' ? 460 : 690, 25, 10, 'F');
        pdf.fromHTML(`<p style="font-size: ${ pdfSize === 'a4' ? '10px' : '14px' }; font-family: Arial, sans-serif;"><b>Secondary Habitat (Class C):</b> Areas of forest or woodland where koala habitat is comprised of secondary and supplementary food tree</p>`, pdfSize === 'a4' ? 60 : 90, (pdfSize === 'a4' ? 450 : 680));
        pdf.fromHTML(`<p style="font-size: ${ pdfSize === 'a4' ? '10px' : '14px' }; font-family: Arial, sans-serif;">species (primary koala food tree species are absent and secondary food tree species comprise less than 30% of the overstorey trees).</p>`, pdfSize === 'a4' ? 60 : 90, pdfSize === 'a4' ? 455 : 687);
        pdf.fromHTML(`<p style="font-size: ${ pdfSize === 'a4' ? '10px' : '14px' }; font-family: Arial, sans-serif;">Capable of supporting low-density koala populations if some secondary food trees are present.</p>`, pdfSize === 'a4' ? 60 : 90, pdfSize === 'a4' ? 460 : 694);

        pdf.setFillColor('#F1ABF9');
        pdf.rect(pdfSize === 'a4' ? 30 : 60, pdfSize === 'a4' ? 485 : 725, 25, 10, 'F');
        pdf.fromHTML(`<p style="font-size: ${ pdfSize === 'a4' ? '10px' : '14px' }; font-family: Arial, sans-serif;"><b>Unknown Habitat Quality:</b> Areas of vegetation lacking information required to assign one of the above classes.</p>`, pdfSize === 'a4' ? 60 : 90, pdfSize === 'a4' ? 475 : 714);

        pdf.setFillColor('#FDD960');
        pdf.rect(pdfSize === 'a4' ? 30 : 60, pdfSize === 'a4' ? 505 : 745, 25, 10, 'F');
        pdf.fromHTML(`<p style="font-size: ${ pdfSize === 'a4' ? '10px' : '14px' }; font-family: Arial, sans-serif;"><b>Other vegetation:</b> Areas of vegetation without eucalypts.</p>`, pdfSize === 'a4' ? 60 : 90, pdfSize === 'a4' ? 495 : 734);
      }

      if (mainviewProps.showFederalLayer || mainviewProps.showLGALayer || mainviewProps.showStateLayer) {
        pdf.setDrawColor('#0000ff');
        pdf.rect(pdfSize === 'a4' ? pdfWidth - 410 : pdfWidth - 510, pdfHeight - 109, 55, 1);
        pdf.fromHTML(`<p style="width: 50px; font-family: Arial, sans-serif; font-size: 11px; font-weight: bold;">Federal Electorates</p>`, pdfSize === 'a4' ? pdfWidth - 350 : pdfWidth - 450, pdfHeight - 122);

        pdf.setDrawColor('#800080');
        pdf.rect(pdfSize === 'a4' ? pdfWidth - 270 : pdfWidth - 370, pdfHeight - 109, 55, 1);
        pdf.fromHTML(`<p style="width: 50px; font-family: Arial, sans-serif; font-size: 11px; font-weight: bold;">Local Governments</p>`, pdfSize === 'a4' ? pdfWidth - 210 : pdfWidth - 310, pdfHeight - 122);

        pdf.setDrawColor('#A52A2A');
        pdf.rect(pdfSize === 'a4' ? pdfWidth - 140 : pdfWidth - 240, pdfHeight - 109, 55, 1);
        pdf.fromHTML(`<p style="width: 50px; font-family: Arial, sans-serif; font-size: 11px; font-weight: bold;">State Electorates</p>`, pdfSize === 'a4' ? pdfWidth - 80 : pdfWidth - 180, pdfHeight - 122);
      }
      // ---------------------

      // PDF Footer ----
      pdf.fromHTML(`<div style="font-family: Arial, sans-serif; font-size: 10px; color: #00690F">Please support Koalamap by making a donation online</div>`, pdfSize === 'a4' ? 142 : 222, pdfHeight - 105);
      pdf.fromHTML(`<div style="font-family: Arial, sans-serif; font-size: 12px; color: #00690F">www.savethekoala.com/koala-map</div>`, pdfSize === 'a4' ? 160 : 240, pdfHeight - 98);
      pdf.fromHTML(`<div style="width: 100px; font-family: Arial, sans-serif; font-size: 11px;">
                      <p style="color: #00690F; margin-bottom: 0; font-size: 12px;">Australian Head Office</p>
                      <span style="display: block;">Australian Koala Foundation</span>
                      <span style="display: block;">ACN 010 922 102</span>
                      <span style="display: block;">ABN 90 010 922 102</span>
                      <span style="display: block;">GPO Box 2659,</span>
                      <span style="display: block;">Brisbane, QLD, 4001</span>
                      <span style="display: block;">Ph: 61-7-3229 7233</span>
                      <span style="display: block;">Fax: 61-7-3221 0337</span>
                      <span style="display: block;">Email: akf@savethekoala.com</span>
                    </div>`, pdfSize === 'a4' ? 30 : 110, pdfHeight - 95);
    
      pdf.fromHTML(`<div style="width: 100px; font-family: Arial, sans-serif; font-size: 11px;">
                      <p style="color: #00690F; margin-bottom: 0; font-size: 12px;">USA Registered Office</p>
                      <span style="display: block;">Friends of the AKF</span>
                      <span style="display: block;">c/o The Nolan Lehr Group Inc.</span>
                      <span style="display: block;">112 East 17th Street</span>
                      <span style="display: block;">Suite #1W</span>
                      <span style="display: block;">New York, NY 10003 USA</span>
                      <span style="display: block;">Ph: 1-212-967 8200</span>
                      <span style="display: block;">Fax: 1-212-967 7292</span>
                    </div>`, pdfSize === 'a4' ? 130 : 210, pdfHeight - 95);
    
      pdf.fromHTML(`<div style="width: 100px; font-family: Arial, sans-serif; font-size: 11px;">
                      <p style="color: #00690F; margin-bottom: 0; font-size: 12px;">USA Correspondence</p>
                      <span style="display: block;">Friends of the AKF</span>
                      <span style="display: block;">C/-ATC International LLC</span>
                      <span style="display: block;">1638 R Street, NW Suite 217</span>
                      <span style="display: block;">Washington DC 20009 USA</span>
                      <span style="display: block;">Ph: 1-202-299 1151</span>
                      <span style="display: block;">Fax: 1-202-299 1153</span>
                    </div>`, pdfSize === 'a4' ? 230 : 310, pdfHeight - 95);
    
      pdf.fromHTML(`<div style="width: 100px; font-family: Arial, sans-serif; font-size: 11px;">
                      <p style="color: #00690F; margin-bottom: 0; font-size: 12px;">Japan Donations</p>
                      <span style="display: block;">Australian Koala Foundation</span>
                      <span style="display: block;">Post Office Remittance Number:</span>
                      <span style="display: block;">Koala Kikin 00100-8-762653</span>
                      <span style="display: block;">At all post offices in Japan</span>
                    </div>`, pdfSize === 'a4' ? 330 : 410, pdfHeight - 95);
      // ---------------
     
      pdf.save(`Koalamap_${ pdfSize }_${ date }.pdf`);
      
      Helper.setNotification('success', 'Success', 'Your PDF was printed successfully.', true);
    }
    catch (e) {
      Helper.setNotification('danger', 'Error', 'There was a problem printing the PDF. Please try again later.', true);
    }
    finally {
      dispatch(setAppLoadingState(false));
    }
  }

  const _checkForSightingAdd = () => {

    if (mainviewProps.isChoosingLocation) return Helper.setNotification('info', 'Unable to continue', 'Please finish choosing a sighting location before doing anything else.', true);

    dispatch(setSidebarItem(sidebarProps.sidebarItem === 'Export' ? '' : 'Export'))
  }

  const itemShown = sidebarProps.sidebarItem === 'Export';

  return (
    <>
      <span className={ `sidebar__item sidebar__item--hidden-mobile ${ itemShown ? 'sidebar__item--active' : '' }` } onClick={ () => _checkForSightingAdd() } title="Print a PDF of the current map view">
        <i className="sidebar__icon far fa-file-pdf"></i>
        <span className="sidebar__text">Print PDF</span>
      </span>

      <div className={ `sidebar__sub-nav ${ itemShown ? 'sidebar__sub-nav--show' : '' }` }>
        <span className="sidebar__sub-nav-item" onClick={ () => _exportPDF('a4') } title="Print the map view as an A4 PDF">Print as A4</span>
        <span className="sidebar__sub-nav-item" onClick={ () => _exportPDF('a3') } title="Print the map view as an A3 PDF">Print as A3</span> 
      </div>
    </>
  );

}

export default ExportItem;